module.exports = __webpack_public_path__ + "68bf8782a57420a8fc6fc216bb0d5ea5.svg";